// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/@radix-ui/colors/black-alpha.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/@radix-ui/colors/mauve.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/@radix-ui/colors/violet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reset */
.select {
    margin-top: 0.75rem;
    display: inline-flex;
    height: 3.0rem;
    align-items: center;
    justify-content: space-between;
    gap: 0.25rem;
    border: 1px solid rgb(30, 48, 80);
    border-radius: 0.25rem;
    background-color: white;
    padding-left: 1rem;
    padding-right: 1rem;
    color: black;
    --csstools-color-scheme--dark:  ;
    color-scheme: light;
    width: 100%;
}

.select:hover {
    background-color: #ede9fe;
}

.select-icon {
    translate: 4px 0;
}

.popover {
    z-index: 50;
    max-height: min(var(--radix-select-content-available-height), 336px);
    border-radius: 0.5rem;
    background-color: white;
    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.25),
    0 4px 6px -4px rgb(0 0 0 / 0.1);
    --csstools-color-scheme--dark:  ;
    color-scheme: light;
    width: 300px;
}

@media (min-width: 640px) {
    .popover {
        width: 500px;
    }
}

.item {
    position: relative;
    display: flex;
    height: 2.5rem;
    cursor: default;
    scroll-margin-top: 0.25rem;
    scroll-margin-bottom: 0.25rem;
    align-items: center;
    border-radius: 0.25rem;
    padding-left: 1.75rem;
    padding-right: 1.75rem;
    color: black;
    outline: 2px solid transparent;
    outline-offset: 2px;
}

.item[data-highlighted] {
    outline: none;
    background-color: var(--violet-9);
    color: var(--violet-1);
    cursor: pointer;
}

@media (min-width: 640px) {
    .item {
        height: 2.25rem;
        font-size: 15px;
    }
}

.item-indicator {
    position: absolute;
    left: 0.375rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/templates/mainForm/style.css"],"names":[],"mappings":"AAIA,UAAU;AACV;IACI,mBAAmB;IACnB,oBAAoB;IACpB,cAAc;IACd,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,iCAAiC;IACjC,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gCAAmB;IAAnB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,oEAAoE;IACpE,qBAAqB;IACrB,uBAAuB;IACvB;mCAC+B;IAC/B,gCAAmB;IAAnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;AAClB","sourcesContent":["@import \"@radix-ui/colors/black-alpha.css\";\n@import \"@radix-ui/colors/mauve.css\";\n@import \"@radix-ui/colors/violet.css\";\n\n/* reset */\n.select {\n    margin-top: 0.75rem;\n    display: inline-flex;\n    height: 3.0rem;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.25rem;\n    border: 1px solid rgb(30, 48, 80);\n    border-radius: 0.25rem;\n    background-color: white;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    color: black;\n    color-scheme: light;\n    width: 100%;\n}\n\n.select:hover {\n    background-color: #ede9fe;\n}\n\n.select-icon {\n    translate: 4px 0;\n}\n\n.popover {\n    z-index: 50;\n    max-height: min(var(--radix-select-content-available-height), 336px);\n    border-radius: 0.5rem;\n    background-color: white;\n    box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.25),\n    0 4px 6px -4px rgb(0 0 0 / 0.1);\n    color-scheme: light;\n    width: 300px;\n}\n\n@media (min-width: 640px) {\n    .popover {\n        width: 500px;\n    }\n}\n\n.item {\n    position: relative;\n    display: flex;\n    height: 2.5rem;\n    cursor: default;\n    scroll-margin-top: 0.25rem;\n    scroll-margin-bottom: 0.25rem;\n    align-items: center;\n    border-radius: 0.25rem;\n    padding-left: 1.75rem;\n    padding-right: 1.75rem;\n    color: black;\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n}\n\n.item[data-highlighted] {\n    outline: none;\n    background-color: var(--violet-9);\n    color: var(--violet-1);\n    cursor: pointer;\n}\n\n@media (min-width: 640px) {\n    .item {\n        height: 2.25rem;\n        font-size: 15px;\n    }\n}\n\n.item-indicator {\n    position: absolute;\n    left: 0.375rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
